import logo from './logo.svg'
import newsImage from './banner.jpg'

export const theme = {
    color: {
      primary: "#B90F22",
      primaryHover: "#7B0B18",
    },
    logoImage: logo,
    backend: "https://tu-darmstadt.epaper-publishing-one.de/",
    directory: "/kiosk",
    header: {
      customer: "",
      title: "TU Darmstadt – e-paper Publikationen",
      lineHeader: true,
    },
      newsSlider: {
      image: newsImage
    },
    info: [
      {
        text: 'Impressum',
        link: 'https://www.tu-darmstadt.de/impressum'
      },
      {
        text: 'Datenschutz',
        link: 'https://www.tu-darmstadt.de/datenschutzerklaerung.de.jsp'
      }
  ]
  };
